import {
    API_GetFinishedTasks,
  } from '../../apiCalls/api.js';
//import { useToast } from "vue-toastification";
//import i18n from '../../locales/i18n'
  
//const toast = useToast();

const state = () => ({
    taskdata: [],
    objectnaming:{}
})

// getters
const getters = {
}

//actions
const actions = {
    
    async getTaskData({ commit }){
        const tasksResponse = await API_GetFinishedTasks();
        var list=[];
        for (const task of tasksResponse.data.Tasks) {
            var dict = {};
            dict["Id"] = task.Id;
            dict["HasReport"] = task.HasReport;
            dict["Nr"] = task.Nr;
            dict["Hidden"] = true;
            dict["InspectionCreated"] = task.InspectionCreated.substring(0,10);
            dict["InspectionModified"] = task.InspectionModified.substring(0,10);
            dict["Location"] = JSON.parse(JSON.stringify(task.Location));
            dict["Equipments"] = [];
            dict["Contact"] = task.ContactName
            list.push(dict)
        }
        commit('setTaskData', list);
    },
}

const mutations = {
   setTaskData(state, data){
    state.taskdata = data;
   },
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }